import React from "react";

import { Headline } from "../../components/Headline";
import { SectionContainer } from "../../components/SectionContainer";
import { MediaBlurbItem } from "./MediaBlurbItem/MediaBlurbItem";
import { Tagline } from "../../components/Tagline/Tagline";

import * as styles from "./mediaBlurb.module.less";

function MediaBlurb({
    data: {
        anker,
        tagline,
        headline,
        semanticOfHeadline,
        left,
        right,
        background
    },
}) {
    return (
        <SectionContainer
            sectionId={anker}
            sectionClass={styles.mediaBlurbContentSection}
            containerClass={styles.mediaBlurbContainer}
            background={background}
        >
            <div className={styles.mediaBlurbBlock}>
                <Tagline>{tagline}</Tagline>
                <Headline semanticOfHeadline={semanticOfHeadline}>
                    {headline}
                </Headline>
                <div className={styles.contentContainer}>
                    <div className={styles.leftContainer}>
                        {left.map((item) => (
                            <MediaBlurbItem key={item.id} item={item} />
                        ))}
                    </div>
                    <div className={styles.rightContainer}>
                        {right.map((item) => (
                            <MediaBlurbItem key={item.id} item={item} />
                        ))}
                    </div>
                </div>
            </div>
        </SectionContainer>
    );
}

export { MediaBlurb };
